export default __webpack_public_path__ + "dropdown-preview.53dc6c57.png";